/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Cc_Position_Top_RightInputs */



/**
* | output |
* | --- |
* | "Position Events to the top right of the video" |
*
* @param {Shortcut_Keys_Desc_Cc_Position_Top_RightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_cc_position_top_right = /** @type {((inputs?: Shortcut_Keys_Desc_Cc_Position_Top_RightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Cc_Position_Top_RightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Positionner les evenements en haut a droite de la video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Positionieren Sie die Ereignisse oben rechts im Video.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posiziona gli eventi in alto a destra del video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разместите события в правом верхнем углу видео.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Colocar eventos en la parte superior derecha del vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频右上角的位置事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントをビデオの右上に配置する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो के ऊपरी दाएं कोने में इवेंट्स को रखें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posicione os eventos no canto superior direito do vídeo.")
	return /** @type {LocalizedString} */ ("Position Events to the top right of the video")
});